<template>
  <div class="notes-container">
    <div>
      <vs-textarea
          label="Escribe un comentario"
          v-model="message.note"
          @keyup.enter="sendNote()"></vs-textarea>

      <div class="input-group mb-3">
        <vs-button
            class="mr-4"
            color="dark"
            :icon="message.is_private ? 'lock': 'lock_open'"
            @click="message.is_private = !message.is_private">
        </vs-button>

        <vs-button icon="send" :disabled="message.note === ''" @click="sendNote()">
        </vs-button>
      </div>
      <small class="label label-pm" v-if="message.is_private">Mensaje marcado como privado</small>
    </div>
    <table class="table table-sm" v-if="messages.length > 0">
      <tr v-if="!isLoaded">
        <td>
          Espere porfavor...
        </td>
      </tr>
      <tr v-for="message in messages" v-bind:key="message.id" v-else>
        <td width="120px">
                    <span class="label label-status-10">
                        <em class="far fa-clock"></em>
                        {{ message.created_at|human_date }}
                    </span>
        </td>
        <td>
          <span class="label label-status-8"><em class="fa fa-user"></em>&nbsp; {{ message.user.email }}</span> <br>

          <div class="note-pad">
            <em class="material-icons" style="font-size:12px;" v-if="message.private">lock</em>
            {{ message.note }}
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import {AxiosErrorException} from '../../functions/axiosErrorException';
import * as moment from 'moment'

export default {
  props: ['project_id', 'autobinding'],
  filters: {
    human_date(date) {
      return moment(date).locale("es").format("D MMM H:m");
    }
  },
  data() {
    return {
      isLoaded: false,
      message: {
        note: "",
        project_id: "",
        is_private: true
      },
      messages: []
    }
  },
  mounted() {
    if (this.autobinding || typeof this.autobinding == "undefined") {
      this.isLoaded = false
      this.getNotes()
    }
  },
  methods: {
    getNotes() {
      axios.get("/api/project/" + this.project_id + "/notes?order_by=created_at:desc")
          .then((res) => {
            this.messages = res.data
            this.isLoaded = true
          })
    },
    sendNote() {
      this.message.project_id = this.project_id;
      axios.post("/api/project/" + this.project_id + "/notes", this.message)
          .then((res) => {
            swal("Ok!", "La nota se guardo correctamente!", "success")
            this.message.note = ""
            this.$emit("sended", res.data)
            this.getNotes()
          })
          .catch((err) => {
            swal("Ups!", AxiosErrorException(err), "error")
          })
    }
  }
}
</script>
<style lang="css" scoped>
.notes-container {
  max-height: 280px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.table td, .table th {
  border-top: none !important;
}

.note-pad {
  background: #e0e0e0;
  padding: 5px;
  margin-top: 5px;
}
</style>
